import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_patient_summary = _resolveComponent("patient-summary")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "ma-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_patient_summary, { patient: _ctx.patient }, null, 8, ["patient"]),
      (_ctx.visit)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { col: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.visit.type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visit.type) = $event)),
                        label: "Encounter",
                        items: _ctx.encounterTypeItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.visit.visit,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visit.visit) = $event)),
                        label: "Visit Type",
                        items: _ctx.visitTypeItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.visit.movement,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visit.movement) = $event)),
                        label: "Movement Type",
                        items: _ctx.movementTypeItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { col: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.visit.date,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visit.date) = $event)),
                        label: "Admission Date",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        type: "date",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.visit.location,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visit.location) = $event)),
                        label: "Location",
                        items: _ctx.locationItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.visit.patientClass,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visit.patientClass) = $event)),
                        label: "Class",
                        items: _ctx.patientClassItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.visit.accomodation,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visit.accomodation) = $event)),
                        label: "Accomodation",
                        items: _ctx.accomodationItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}